/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_StartingInputs */

const en_audio_description_export_status_starting = /** @type {(inputs: Audio_Description_Export_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting Export...`)
};

const fr_audio_description_export_status_starting = /** @type {(inputs: Audio_Description_Export_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage de l'exportation...`)
};

const de_audio_description_export_status_starting = /** @type {(inputs: Audio_Description_Export_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export wird gestartet...`)
};

const it_audio_description_export_status_starting = /** @type {(inputs: Audio_Description_Export_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio esportazione...`)
};

const ru_audio_description_export_status_starting = /** @type {(inputs: Audio_Description_Export_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало экспорта...`)
};

const es_audio_description_export_status_starting = /** @type {(inputs: Audio_Description_Export_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando Exportación...`)
};

const zh_cn2_audio_description_export_status_starting = /** @type {(inputs: Audio_Description_Export_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始导出...`)
};

const ja_audio_description_export_status_starting = /** @type {(inputs: Audio_Description_Export_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートを開始しています...`)
};

const hi_audio_description_export_status_starting = /** @type {(inputs: Audio_Description_Export_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात शुरू हो रहा है...`)
};

const pt_pt2_audio_description_export_status_starting = /** @type {(inputs: Audio_Description_Export_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando a exportação...`)
};

/**
* | output |
* | --- |
* | "Starting Export..." |
*
* @param {Audio_Description_Export_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_starting = /** @type {((inputs?: Audio_Description_Export_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_starting(inputs)
	if (locale === "de") return de_audio_description_export_status_starting(inputs)
	if (locale === "it") return it_audio_description_export_status_starting(inputs)
	if (locale === "ru") return ru_audio_description_export_status_starting(inputs)
	if (locale === "es") return es_audio_description_export_status_starting(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_starting(inputs)
	if (locale === "ja") return ja_audio_description_export_status_starting(inputs)
	if (locale === "hi") return hi_audio_description_export_status_starting(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_starting(inputs)
	return en_audio_description_export_status_starting(inputs)
});